(function() {
  const moneyFormat = window.themeVariables?.settings?.moneyFormat || 'Rs. {{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents);
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = moneyFormat || 'Rs. {{amount}}';

    function defaultOption(opt, def) {
       return (typeof opt === 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
       precision = defaultOption(precision, 2);
       thousands = defaultOption(thousands, ',');
       decimal   = defaultOption(decimal, '.');

       if (isNaN(number) || number == null) { return 0; }

       number = (number/100.0).toFixed(precision);

       var parts   = number.split('.'),
           dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
           cents   = parts[1] ? (decimal + parts[1]) : '';

       return dollars + cents;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return (cents/100.0).toFixed(2);

    switch(match[1]) {
       case 'amount':
         value = formatWithDelimiters(cents, 2);
         break;
       case 'amount_no_decimals':
         value = formatWithDelimiters(cents, 0);
         break;
       case 'amount_with_comma_separator':
         value = formatWithDelimiters(cents, 2, '.', ',');
         break;
       case 'amount_no_decimals_with_comma_separator':
         value = formatWithDelimiters(cents, 0, '.', ',');
         break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initMyntraFBT() {
    const mainSection = document.querySelector('.best-match-section');
    if (!mainSection || mainSection.dataset.initialized) return;
    mainSection.dataset.initialized = 'true';

    // UI Nodes
    const grid = mainSection.querySelector('.fbt-grid');
    const checkboxes = mainSection.querySelectorAll('.fbt-item-checkbox');
    const selectBtn = mainSection.querySelector('.fbt-buy-btn');
    const selectBtnText = selectBtn.querySelector('.fbt-buy-btn__text');
    const countEl = mainSection.querySelector('.fbt-summary-count');
    const totalPriceEl = mainSection.querySelector('.fbt-total-price');
    const comparePriceEl = mainSection.querySelector('.fbt-total-compare-price');
    const savingsEl = mainSection.querySelector('.fbt-total-savings');

    // Drawer Nodes
    const drawerMask = document.querySelector('.fbt-drawer-mask');
    const drawer = document.querySelector('.fbt-drawer');
    const drawerBody = drawer.querySelector('.fbt-drawer__body');
    const drawerCloseBtn = drawer.querySelector('.fbt-drawer__close');
    const drawerSubmitBtn = drawer.querySelector('.fbt-drawer-submit-btn');
    const drawerSubmitText = drawerSubmitBtn.querySelector('.fbt-drawer-submit-btn__text');
    const drawerSubmitSpinner = drawerSubmitBtn.querySelector('.fbt-drawer-submit-btn__spinner');

    // Load static product JSON
    const productsJsonEl = document.getElementById('fbt-products-json');
    if (!productsJsonEl) return;
    const productsData = JSON.parse(productsJsonEl.textContent);

    function updateSummaryBar() {
      const activeCheckboxes = mainSection.querySelectorAll('.fbt-item-checkbox:checked');
      countEl.textContent = activeCheckboxes.length;

      if (activeCheckboxes.length === 0) {
        selectBtn.disabled = true;
        selectBtnText.textContent = 'Select items to buy';
        totalPriceEl.textContent = formatMoney(0);
        comparePriceEl.style.display = 'none';
        savingsEl.style.display = 'none';
        return;
      }

      selectBtn.disabled = false;
      selectBtnText.textContent = 'Select and Buy';

      let total = 0;
      let compareTotal = 0;

      activeCheckboxes.forEach(cb => {
        total += parseInt(cb.dataset.price);
        compareTotal += parseInt(cb.dataset.comparePrice);
      });

      totalPriceEl.textContent = formatMoney(total);

      if (compareTotal > total) {
        comparePriceEl.textContent = formatMoney(compareTotal);
        comparePriceEl.style.display = 'inline';

        const discountPercent = Math.round(((compareTotal - total) * 100) / compareTotal);
        savingsEl.textContent = `(${discountPercent}% OFF)`;
        savingsEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
        savingsEl.style.display = 'none';
      }
    }

    // Handle checkboxes inside the grid
    checkboxes.forEach(cb => {
      cb.addEventListener('change', updateSummaryBar);
    });

    // Listen to parent variant picker change
    document.addEventListener('variant:changed', function(event) {
      const variant = event.detail.variant;
      if (!variant) return;
      
      const mainCard = mainSection.querySelector('.fbt-item--main');
      if (!mainCard) return;

      const checkbox = mainCard.querySelector('.fbt-item-checkbox');
      checkbox.value = variant.id;
      checkbox.dataset.price = variant.price;
      checkbox.dataset.comparePrice = variant.compare_at_price || variant.price;
      checkbox.dataset.available = variant.available ? 'true' : 'false';

      // Update subtitle label
      const subtitleEl = mainCard.querySelector('.fbt-item__subtitle');
      if (subtitleEl) subtitleEl.textContent = `Size: ${variant.title}`;

      // Update card pricing HTML
      const priceEl = mainCard.querySelector('.fbt-item__price');
      if (priceEl) {
        if (variant.compare_at_price > variant.price) {
          const savings = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          priceEl.innerHTML = `
            <span class="price price--highlight">${formatMoney(variant.price)}</span>
            <span class="price price--discount">(${savings}% OFF)</span>
          `;
        } else {
          priceEl.innerHTML = `<span class="price">${formatMoney(variant.price)}</span>`;
        }
      }

      if (!variant.available) {
        checkbox.checked = false;
        checkbox.disabled = true;
      } else {
        checkbox.disabled = false;
        checkbox.checked = true;
      }

      updateSummaryBar();
    });

    // Modal Control Functions
    function openDrawer() {
      // Build selected list
      drawerBody.innerHTML = '';
      const checkedCheckboxes = mainSection.querySelectorAll('.fbt-item-checkbox:checked');
      
      let multiVariantCount = 0;

      checkedCheckboxes.forEach(cb => {
        const itemCard = cb.closest('.fbt-item');
        const productId = itemCard.dataset.productId;
        const pData = productsData[productId];
        const isMain = cb.dataset.isMain === 'true';

        if (!pData) return;

        const drawerItem = document.createElement('div');
        drawerItem.className = 'fbt-drawer-item';
        drawerItem.dataset.productId = productId;

        // Image
        const img = document.createElement('img');
        img.className = 'fbt-drawer-item__img';
        img.src = pData.image;
        img.alt = pData.title;
        drawerItem.appendChild(img);

        // Details
        const info = document.createElement('div');
        info.className = 'fbt-drawer-item__info';

        const title = document.createElement('div');
        title.className = 'fbt-drawer-item__title';
        title.textContent = pData.title;
        info.appendChild(title);

        const priceEl = document.createElement('div');
        priceEl.className = 'fbt-drawer-item__price';
        priceEl.textContent = formatMoney(cb.dataset.price);
        info.appendChild(priceEl);

        // Size selector logic
        if (isMain) {
          // Main product sizes are pre-selected at the top, just show the selected label
          const selectedVariant = pData.variants.find(v => v.id === parseInt(cb.value));
          const label = document.createElement('span');
          label.className = 'fbt-drawer-item__variant-label';
          label.textContent = `Selected: ${selectedVariant ? selectedVariant.title : cb.value}`;
          info.appendChild(label);

          // Save active variant id as input hidden
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.className = 'fbt-drawer-item-value';
          hiddenInput.value = cb.value;
          drawerItem.appendChild(hiddenInput);
        } else if (pData.variants.length > 1) {
          multiVariantCount++;
          // Render size dropdown select for matching products
          const selectWrapper = document.createElement('div');
          selectWrapper.className = 'fbt-drawer-item__select-wrapper';

          const select = document.createElement('select');
          select.className = 'fbt-drawer-item__select fbt-drawer-item-value';
          select.ariaLabel = `Select variant for ${pData.title}`;

          pData.variants.forEach(v => {
            const opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title + (v.available ? ` - ${formatMoney(v.price)}` : ' (Out of stock)');
            if (!v.available) opt.disabled = true;
            
            // Default select first available variant or current checked variant value
            if (parseInt(cb.value) === v.id) {
              opt.selected = true;
            }
            select.appendChild(opt);
          });

          // Update price display inside drawer on dropdown change
          select.addEventListener('change', function() {
            const activeOpt = this.options[this.selectedIndex];
            const matchingVariant = pData.variants.find(v => v.id === parseInt(this.value));
            if (matchingVariant) {
              priceEl.textContent = formatMoney(matchingVariant.price);
            }
          });

          selectWrapper.appendChild(select);
          info.appendChild(selectWrapper);
        } else {
          // Single variant item, just use default title
          const label = document.createElement('span');
          label.className = 'fbt-drawer-item__variant-label';
          label.textContent = pData.variants[0].title;
          info.appendChild(label);

          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.className = 'fbt-drawer-item-value';
          hiddenInput.value = pData.variants[0].id;
          drawerItem.appendChild(hiddenInput);
        }

        drawerItem.appendChild(info);
        drawerBody.appendChild(drawerItem);
      });

      // Bypasses the drawer if NO checked matching items have multiple sizes/variants
      if (multiVariantCount === 0) {
        // Direct AJAX Add to Cart
        ajaxAddToCartDirectly(checkedCheckboxes);
        return;
      }

      // Otherwise show size selection drawer
      drawerMask.classList.add('is-open');
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // prevent scrolling behind modal
    }

    function closeDrawer() {
      drawerMask.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Direct add helper
    function ajaxAddToCartDirectly(checkboxes) {
      const items = Array.from(checkboxes).map(cb => ({
        id: parseInt(cb.value),
        quantity: 1
      }));
      postCartItems(items);
    }

    // POST request logic
    function postCartItems(items) {
      // Show loading states
      selectBtn.disabled = true;
      const originalBtnText = selectBtnText.textContent;
      selectBtnText.textContent = 'Adding to cart...';

      drawerSubmitBtn.disabled = true;
      drawerSubmitText.textContent = 'Adding...';
      drawerSubmitSpinner.style.display = 'inline-block';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(data => {
        // Success checkmark
        selectBtnText.textContent = 'Added to Cart! ✨';
        drawerSubmitText.textContent = 'Added! ✨';
        drawerSubmitSpinner.style.display = 'none';

        // Trigger cart drawer refresh
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        // Open theme mini-cart
        const miniCart = document.getElementById('mini-cart');
        if (miniCart) {
          miniCart.open = true;
        }

        setTimeout(() => {
          closeDrawer();
          selectBtn.disabled = false;
          drawerSubmitBtn.disabled = false;
          drawerSubmitText.textContent = 'Confirm & Add to Cart';
          updateSummaryBar();
        }, 1500);
      })
      .catch(error => {
        console.error('AJAX add error:', error);
        alert('Could not add bundle items. Please check that selected sizes are available.');
        
        selectBtnText.textContent = originalBtnText;
        selectBtn.disabled = false;
        
        drawerSubmitText.textContent = 'Confirm & Add to Cart';
        drawerSubmitSpinner.style.display = 'none';
        drawerSubmitBtn.disabled = false;
      });
    }

    // Drawer action triggers
    selectBtn.addEventListener('click', openDrawer);
    drawerCloseBtn.addEventListener('click', closeDrawer);
    drawerMask.addEventListener('click', closeDrawer);

    // Confirm button inside drawer
    drawerSubmitBtn.addEventListener('click', function() {
      const inputs = drawer.querySelectorAll('.fbt-drawer-item-value');
      const items = Array.from(inputs).map(inp => ({
        id: parseInt(inp.value),
        quantity: 1
      }));
      
      if (items.length > 0) {
        postCartItems(items);
      }
    });

    // Populate initial counts and totals on load
    updateSummaryBar();
  }

  // Load handler
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMyntraFBT);
  } else {
    initMyntraFBT();
  }
})();